import styled from 'styled-components';
import { LegalTermsAndConditionsConsentStyled } from '../../LegalTermsAndConditionsConsentStyled';
import { rem } from 'polished';

export const LegalTermsAndConditionsConsentStyledOV = styled(LegalTermsAndConditionsConsentStyled)`
    .section {
        &_title {
            border-bottom: 1px solid ${({ theme }) => theme.colors.grey11};

            span {
                color: ${({ theme }) => theme.colors.black2};
                font-weight: ${({ theme }) => theme.fontWeights.textRegular};
            }

            .isOpen {
                svg {
                    path {
                        stroke-width: 0;
                        fill: ${({ theme }) => theme.colors.primary};
                    }
                }
            }

            svg {
                path {
                    fill: ${({ theme }) => theme.colors.primary};
                    stroke-width: 0;
                }
            }
        }

        &_description {
            color: ${({ theme }) => theme.colors.black2};
            font-size: ${({ theme }) => theme.fontSizes.h5};
            line-height: ${rem(16)};
            border-bottom: 1px solid ${({ theme }) => theme.colors.grey11};
            padding: ${rem(8)} ${rem(16)} ${rem(16)} ${rem(16)};
        }

        &_agreements {
            &_agreement {
                input {
                    accent-color: ${({ theme }) => theme.colors.primary};
                }

                button {
                    color: ${({ theme }) => theme.colors.black2};
                }
            }
        }
    }

    .legend {
        color: ${({ theme }) => theme.colors.black2};
        font-size: ${({ theme }) => theme.fontSizes.h5};
        line-height: ${rem(16)};
    }
`;
